<template>
    <div
    >
      <table class="confined-space-apr-list__table table-striped table-bordered">
        <thead>
          <tr class="bg-secondary text-light">
            <th class="text-center">ID</th>
            <th class="text-center">Foto</th>
            <th class="text-center">Nº B.V.</th>
            <th class="text-center">Dimensões</th>
            <th class="text-center">
              <div class="rotated">Natureza do Risco</div>
            </th>
            <th class="text-center">
              <div class="rotated">Multa prevista (R$)</div>
            </th>
            <th class="text-center">
              <div class="rotated">Item da Norma</div>
            </th>
            <th class="text-center">Descrição</th>
            <th class="text-center">Tratativa</th>
            <th class="text-center">Observações</th>
            <th class="text-center">Consequências</th>
            <th class="text-center">Probabilidade</th>
            <th
              class="text-center"
              @click="showSingleImage(CONFINED_SPACE_RISKS.methodology)"
              style="text-decoration: underline; cursor: pointer;"
            >
              Grau de Risco
            </th>
            <th class="text-center no-print">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="apr in confinedSpaceAprs"
            :key="apr.id"
            class="confined-space-apr-list__item prevent-print-cut text-center"
          >
            <td>{{ apr.id }}</td>
            <td>
              <div v-if="apr.picture">
                <img
                  class="table-image expandable-image"
                  :src="apr.picture_url"
                  alt=""
                  @click="showSingleImage(apr.picture_url)"
                />
              </div>
            </td>
            <td class="text-vertical">
              <div class="rotated">
                {{
                  apr.confined_space_entry_id ?
                  getEntryPosition(apr.confined_space_entry_id) + 1
                  : '-'
                }}
              </div>
            </td>
            <td class="text-vertical">
              <div class="rotated">
                <span v-if="apr.confined_space_entry">
                  <span v-if="apr.confined_space_entry.diameter">
                    Diâmetro: {{ apr.confined_space_entry.diameter }}
                  </span>
                  <span v-else>
                    Altura: {{ apr.confined_space_entry.height }}
                    Largura: {{ apr.confined_space_entry.width }}
                  </span>
                </span>
                <span v-else>
                  {{ '-' }}
                </span>
              </div>
            </td>
            <td class="text-vertical">
              <div class="rotated">
                {{ apr?.nature_of_risk_alternative || '-' }}
              </div>
            </td>
            <td class="text-vertical">
              <div class="rotated">
                {{ apr?.max_fine_value || '-' }}
              </div>
            </td>
            <!-- Natureza do risco -->
            <td class="text-vertical">
              <div class="rotated">
                {{
                  apr?.standard_item_alternative ||
                  standardItemsToString(apr) ||
                  '-'
                }}
              </div>
            </td>
            <td class="text-sm text-vertical">
              <div class="rotated">
                {{ apr?.noncompliance_model.description }}
              </div>
            </td>
            <!-- Descrição -->
            <td class="text-sm">
              {{ apr.noncompliance_model.treatise }}
            </td>
            <!-- Tratativa -->
            <td class="text-sm">
              {{ apr.additional_observations || '-' }}
            </td>
            <td>
              {{ 
                noncompliance_model_consequences.filter(
                  p => p.value == apr.noncompliance_model.consequences
                )[0].name
              }}
            </td>
            <td>
              {{ 
                noncompliance_model_probabilities.filter(
                  p => p.value == apr.noncompliance_model.probability
                )[0].name
              }}
            </td>
            <td
              :style="{
                backgroundColor: getRiskColor(apr.noncompliance_model.noncompliance_model_degree_of_risk.magnitude),
                cursor: 'default'
              }"
              :title="apr.noncompliance_model.noncompliance_model_degree_of_risk.action"
              class="text-center"
            >
              {{ apr.noncompliance_model.noncompliance_model_degree_of_risk.name }}
            </td>
            <td class="no-print" v-if="authenticated_user !== 'Cliente somente leitura'">
              <button @click="edit(apr)" class="btn btn-primary btn-sm">
                Editar
              </button>
              <button @click="remove(apr)" class="btn btn-danger btn-sm mt-2">
                Excluir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'
  import useImageViewer from '@/modules/ImageViewer.js'
  import Dialog from 'primevue/dialog'
  import axios from 'axios'
  import { useStore } from 'vuex'

  import { CONFINED_SPACE_RISKS } from '@/constants/images.constants.js'
  import useConfinedSpaces from '@/modules/ConfinedSpace'
  import useSwal from '@/modules/Swal'
  import { computed } from '@vue/runtime-core'

  export default {
    components: {
      Dialog,
    },
    setup(props) {
      const { showSingleImage } = useImageViewer()
      const { saveConfinedSpaceApr } = useConfinedSpaces()
      const { showSuccessAlert, showErrorAlert, showConfirmDeletionSwal } = useSwal()
      const {
        listProbabilities,
        listConsequences,
        noncompliance_model_probabilities,
        noncompliance_model_consequences,
      } = useDegreeOfRisk()
      const { getRiskColor } = useDegreeOfRisk()
      const store = useStore()
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

      listProbabilities()
      listConsequences()

      return {
        showSingleImage,
        saveConfinedSpaceApr,
        showSuccessAlert,
        showErrorAlert,
        showConfirmDeletionSwal,
        getRiskColor,
        noncompliance_model_probabilities,
        noncompliance_model_consequences,

        CONFINED_SPACE_RISKS,
        authenticated_user
      }
    },
    data() {
      return {
        displayModal: false,
        aprSelected: {
          noncompliance_placement: '',
          noncompliance: '',
          treatise_alternative: '',
          additional_observations: '',
          treatise: ''
        },
        loading: false,
        entries_ids: [],
      }
    },
    props: {
      confinedSpaceAprs: {
        type: Array,
        required: true,
      },
    },
    methods: {
      remove(apr) {
        this.showConfirmDeletionSwal().then(() => {
          axios.delete(`/api/confined-spaces/${apr.risk_analysis.confined_space_id}/risk-analysis/destroy/${apr.id}`).then(() => {
            this.showSuccessAlert()
            location.reload()
          })
        })
      },
      edit(apr) {
        if (apr.confined_space_entry) {
          this.$router.push({
            name: 'confined-spaces-risk-analyses-create',
            params: {
              rad_id: apr.id,
              confined_space_entry_id: apr.confined_space_entry.id
            }
          })
        } else {
          this.$router.push({
            name: 'confined-space-edit',
            params: { id: apr.risk_analysis.confined_space_id }
          })
        }
      },
      standardItemsToString(apr) {
        return (
          apr.noncompliance_model?.standard_items?.reduce((prev, curr) => {
            return `${prev} ${curr.name}`
          }, '') || '-'
        )
      },
      getEntryPosition(entry_id) {
        let entries_ids = this.confinedSpaceAprs.map(apr => apr.confined_space_entry_id)
        entries_ids = [... new Set(entries_ids)].filter(id => id)

        return entries_ids.indexOf(entry_id)
      },
    },
  }

</script>

<style lang="scss" scoped>
  .confined-space-apr-list {
    &__table {
      width: 100%;
    }

    &.print {
      font-size: 0.7rem;
    }
  }

  table {
    font-size: 0.8rem;

    table.inner-table {
      width: 100%;
      background-color: #fff;
      font-size: 0.7rem;

      tr,
      td {
        background-color: #fff;
      }

      tr.table-title td {
        background-color: #ccc;
        text-align: center;
        font-weight: bold;
        font-size: 0.7rem;
      }
    }
  }

  .table-image {
    max-width: 80px;
    max-height: 100px;
    object-fit: cover;
  }

  td:not(.no-padding) {
    padding: 5px;
  }

  .text-sm {
    font-size: 0.75rem;
  }

  .expandable-image {
    cursor: pointer;
  }

  textarea {
    height: 200px;
    width: 100%;
  }

  .close {
    margin-left: auto;
  }
</style>
